// @ts-nocheck
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { ShareEntityModel, TellAFriendModel } from "@insite/client-framework/Types/ApiModels";
import Cookies from "js-cookie";

const emailsUrl = "/api/v1/custom/form/contactUs";

export interface SubmitContactUsFormApiParameter extends ApiParameter {
    subscribeState?: string;
    firstName?: string;
    lastName?: string;
    companyName?: string;
    postalCode?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    emailTo?: string;
    company?: string;
    email?: string;
    fname?: string;
    lname?: string;
    description?: string;
    phone?: string;
    postal?: string;
    optin?: string | undefined;
    utmSource?: string | null;
    utmMedium?: string | null;
    utmCampaign?: string | null;
}

export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    const queryParams = new URLSearchParams(window.location.search);
    const getUtmParams = Cookies.get("utmParams") 
    const storedParams = getUtmParams ? JSON.parse(getUtmParams) : {};
    const newParameter = {
        company: parameter.companyName ? parameter.companyName : "[required]",
        email: parameter.emailAddress ? parameter.emailAddress : "[required]",
        fname: parameter.firstName ? parameter.firstName : "[required]",
        lname: parameter.lastName ? parameter.lastName : "[required]",
        description: parameter.message ? parameter.message : "[required]",
        phone: parameter.phoneNumber ? parameter.phoneNumber : "[required]",
        postal: parameter.postalCode ? parameter.postalCode : "[required]",
        optin: parameter.subscribeState !== undefined ? parameter.subscribeState : "false",
        utmSource: queryParams.has("utm_source") ? queryParams.get("utm_source") : storedParams.utm_source || "",
        utmMedium: queryParams.has("utm_medium") ? queryParams.get("utm_medium") : storedParams.utm_medium || "",
        utmCampaign: queryParams.has("utm_campaign") ? queryParams.get("utm_campaign") : storedParams.utm_campaign || "",
    };
    return post<SubmitContactUsFormApiParameter, void>(`${emailsUrl}`, newParameter);
}
